export const getEditedFields = (newData, prevData) => {
    return Object.keys(newData)
        .filter(key => newData[key] !== prevData[key])
        .map(key => ({
            name: key,
            value: newData[key]
        }));
};
